import React from "react";

const Dashboard = () => {
  return <>Dashboard page under development</>;
};

export default Dashboard;
